import(/* webpackMode: "eager" */ "/vercel/path0/pkg-ui/design-system/src/chakra.ts");
